import { ALERT_ERRORS } from "src/app/core/constants/Errors";
import { GENERAL_CONSTANTS, POP_UP_EXTERNAL_RESPONSES } from "src/app/core/constants/General-constants";

/**
 * @description: Function to build the popup with checkout flow
 * @param url: flow url
 * @param windowTitle: popup window title
*/
export function openAndMonitorWindow(url: string, windowTitle: string) {
    return new Promise((resolve, _) => {
        const screenWidth = window.innerWidth - (window.innerWidth * 0.1);
        const screenHeight = window.innerHeight - (window.innerHeight * 0.2);

        let left = (screen.width - screenWidth) / 2;
        let top = screen.height - (screen.height * 0.8);
        let popupUrl = `${window.location.origin}/popup-service?url=${encodeURIComponent(url)}`

        const popupWindow = window.open(popupUrl, windowTitle, `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${screenWidth},height=${screenHeight},left=${left},top=${top}`);


        if (!popupWindow) {
            if (window.parent === window) return window.location.href = url;

            return resolve({ code: ALERT_ERRORS.POP_UP_BLOCKED, returnUrl: '' });

        }

        window.addEventListener('message', (event) => {
            if (event.data.origin === GENERAL_CONSTANTS.POPUP_BNPL_ORIGIN) {
                clearInterval(interval);
                popupWindow.close();

                return resolve({ code: POP_UP_EXTERNAL_RESPONSES.BNPL_COMPLETED, returnUrl: event.data.returnUrl });
            }

        }, false);

        const interval = setInterval(() => {
            try {

                if (popupWindow.closed) {
                    clearInterval(interval);
                    return resolve({ code: ALERT_ERRORS.PROCESS_WAS_NOT_FINISHED, returnUrl: '' });
                }

            } catch (_) {}
        }, 1000);
    });
}

